// import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";
// import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import * as Fa from "react-icons/fa";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Axios from "../../api/Axios";
import storage from "../../Services/Storage";
import { downloadExcel } from "../../Services/GlobalFunc/downloadExcel";
import { GetDateFormat } from "../../Services/GlobalFunc/DateFormat";
import { toast } from "react-toastify";

const AplusProduct = () => {
    const [divisonOpions, setDivisonOpions] = useState([]);
    const [selectedDivisonOpions, setSelectedDivisonOpions] = useState();
    const [quarterOpions, setQuarterOption] = useState([]);
    const [selectedQuarterOpions, setSelectedQuarterOpions] = useState();
    const [getAllNPIdata, setGetAllNPIdata] = useState([]);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const auth = storage.getLocal("user");
    let div_URL = "NewProdIntro/PopulateDivision?";
    let qtr_URL = "NewProdIntro/PopulateQuarter?";
    let npi_URL = "APlusProd/GetAllAPLUSData?";
    let exp_URL = "APlusProd/ExportData?";

    useEffect(() => {
        const div_api = `${div_URL}`;
        const qtr_api = `${qtr_URL}`;

        const pageonLoad = async () => {
            try {
                const div_res = await Axios.get(div_api);
                const qtr_res = await Axios.get(qtr_api);
                setDivisonOpions(div_res.data.Data);
                setSelectedDivisonOpions(div_res.data.Data[0]);
                setQuarterOption(qtr_res.data.Data);
                setSelectedQuarterOpions(qtr_res.data.Data[0]);
            } catch (error) {
                console.log(error);
            }
        };
        pageonLoad();
    }, []);
    useEffect(() => {
        const quaterchnage = async () => {
            // console.log(selectedQuarterOpions);
            // console.log(selectedDivisonOpions);
            if (
                selectedQuarterOpions?.length !== 0 &&
        selectedDivisonOpions?.length !== 0
            ) {
                try {
                    const npi_api = `${npi_URL}strDivn=${selectedDivisonOpions?.DIVN_ID}&strQtr=${selectedQuarterOpions?.QTR_ID}&CompId=${auth.CompId}`;
                    const npi_res = await Axios.get(npi_api);
                    setGetAllNPIdata(npi_res.data.Data);
                } catch (error) {
                    console.log(error);
                }
            }
        };

        quaterchnage();
    }, [selectedQuarterOpions]);

    const exportdata = async () => {
        setLoadingExcel(true);
        try {
            const exp_api = `${exp_URL}strDivn=${selectedDivisonOpions?.DIVN_ID}&strQtr=${selectedQuarterOpions?.QTR_ID}&CompId=${auth.CompId}`;
            const exp_res = await Axios.get(exp_api);
            // console.log(exp_res.data);
            if (exp_res.data.Data.length == 0) {
                toast.warn("No data found.", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
            } else {
                downloadExcel(exp_res.data.Data, `APLUS_${GetDateFormat()}.xlsx`);
            }

            setLoadingExcel(false);
        } catch (error) {
            console.log(error);
            setLoadingExcel(false);
        }
    };

    return (
        <>
            <div className="col-12 pt-3 pb-5">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">A + Product</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="submit"
                                title="Export"
                                className="btn btn-primary"
                                disabled={loadingExcel}
                                onClick={exportdata}
                            >
                                {loadingExcel ? "Loading..." : "Export"}{" "}
                                {loadingExcel ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                ) : (
                                    <Fa.FaFileExport className="ms-2" />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-end align-items-end">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Division </label>
                                <Dropdown
                                    value={selectedDivisonOpions}
                                    onChange={(e) => {
                                        setSelectedDivisonOpions(e.value);
                                    }}
                                    options={divisonOpions}
                                    optionLabel="DIVN_NAME"
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="d-block mb-2">
                                <label className="form-label">Quarter</label>
                                <Dropdown
                                    value={selectedQuarterOpions}
                                    onChange={(e) => {
                                        setSelectedQuarterOpions(e.value);
                                    }}
                                    options={quarterOpions}
                                    optionLabel="QTR_NAME"
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <h3 className="py-2">Records</h3>
                        <div className="DataTable">
                            <DataTable
                                paginator
                                rows={10}
                                filterDisplay="row"
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                // showGridlines
                                scrollable
                                stripedRows
                                value={getAllNPIdata}
                                emptyMessage="No Record found"
                            >
                                <Column
                                    field="PROD_CODE"
                                    header="Product Code"
                                    filterMatchMode="contains"
                                    filter
                                    filterPlaceholder="Search Here..."
                                ></Column>
                                <Column
                                    field="PROD_SMALL_DESC"
                                    header="Product Description"
                                    filter
                                    filterMatchMode="contains"
                                    filterPlaceholder="Search Here..."
                                />
                            </DataTable>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default AplusProduct;
